var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,52 C11.6405965,52 0,40.3594035 0,26 C0,11.6405965 11.6405965,0 26,0 C40.3594035,0 52,11.6405965 52,26 C52,40.3594035 40.3594035,52 26,52 Z M26,47 C37.5979798,47 47,37.5979798 47,26 C47,14.4020202 37.5979798,5 26,5 C14.4020202,5 5,14.4020202 5,26 C5,37.5979798 14.4020202,47 26,47 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#8A8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,37 C19.9248678,37 15,32.0751322 15,26 C15,19.9248678 19.9248678,15 26,15 C32.0751322,15 37,19.9248678 37,26 C37,32.0751322 32.0751322,37 26,37 Z",
    id: "Combined-Shape-Copy-3",
    fill: "#FA675E"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation",
    attributeName: "opacity",
    values: "0;1;0",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordActive);
export default __webpack_public_path__ + "static/media/recordActive.48b55303f560a14a496190d1a283fe63.svg";
export { ForwardRef as ReactComponent };